import { CSpinner } from "@coreui/react";
import { useState } from "react";
import { useQuery } from "react-query";
import StatisticsCard from "../../components/ui/cards/StatisticsCard";
import SoldeIcon from "../../components/ui/icons/SoldeIcon";
import { useCookie } from "../../hooks/useCookie";
import { Messages } from "../../lang/content";
import apiService from "../../service/api.service";

const RevenuIcon = () => (
	<svg
		width="30"
		height="30"
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M19.3547 38.6939C15.528 38.6954 11.7866 37.5623 8.60452 35.4371C5.42167 33.3122 2.94068 30.2913 1.47506 26.7563C0.00945091 23.2213 -0.374803 19.3308 0.370744 15.5778C1.11632 11.8244 2.9586 8.37618 5.66377 5.66951C8.36895 2.96284 11.8165 1.11951 15.5692 0.372469C19.3226 -0.374926 23.2128 0.00789003 26.7487 1.47203C30.2845 2.93587 33.3065 5.41574 35.4327 8.59747C37.559 11.7792 38.6939 15.5202 38.6939 19.3467H35.4272C35.4272 16.1661 34.4837 13.0568 32.7165 10.4122C30.9494 7.76746 28.4374 5.70647 25.4985 4.48987C22.56 3.2729 19.3261 2.955 16.2067 3.57622C13.0873 4.1971 10.2221 5.72942 7.97368 7.97932C5.72491 10.2288 4.19405 13.0948 3.5746 16.2145C2.95517 19.3343 3.27455 22.5677 4.49298 25.5059C5.71145 28.4441 7.77346 30.955 10.4193 32.7207C13.0647 34.4867 16.1742 35.4285 19.3548 35.427L19.3547 38.6939ZM40 24.5493L37.6969 22.2462L25.1856 34.7491L19.428 28.9672L17.0925 31.2703L25.1856 39.3633L40 24.5493ZM20.2936 26.2478V24.6145C21.5033 24.5525 22.6554 24.08 23.5603 23.275C24.4054 22.4674 24.8556 21.331 24.7937 20.1636C24.8217 19.2091 24.4309 18.2901 23.7236 17.6484C22.8814 16.9349 21.8824 16.4314 20.8084 16.1784L20.8493 12.8136C21.8034 13.0929 22.6459 13.6638 23.2584 14.447L24.7364 12.4053C23.7826 11.2102 22.4049 10.4292 20.89 10.2247V8.69753H18.9052V10.1595C18.1181 10.2295 17.3539 10.4599 16.6594 10.8373C16.0072 11.1741 15.4468 11.6645 15.0261 12.2664C14.6243 12.8555 14.4136 13.5541 14.422 14.2673C14.422 16.4179 15.7261 17.8277 18.3339 18.4975L18.2687 21.9763C17.7448 21.8305 17.2518 21.5899 16.8147 21.2661C16.2752 20.8673 15.7896 20.4006 15.3692 19.8778L13.8011 22.0992C14.3312 22.7638 14.986 23.3187 15.7286 23.7325C16.5066 24.1708 17.3649 24.4486 18.2519 24.5492L18.2111 26.2562L20.2936 26.2478ZM17.8436 13.1812C18.1721 12.9074 18.5713 12.7316 18.9953 12.6748V15.7209C18.5571 15.594 18.1488 15.3804 17.7948 15.0923C17.521 14.8517 17.3638 14.505 17.3638 14.1408C17.3638 13.7766 17.521 13.4299 17.7948 13.1893L17.8436 13.1812ZM21.4698 21.6093C21.1154 21.8772 20.6947 22.0438 20.2528 22.0909L20.1956 18.9467C20.6593 19.0856 21.0924 19.3127 21.4697 19.6164C21.7519 19.8851 21.9014 20.2646 21.8781 20.6536C21.893 21.0251 21.7326 21.3817 21.4453 21.6172L21.4698 21.6093Z"
			fill="#29129D"
		/>
	</svg>
);

export default function StatisticsDetails() {
	const { token } = useCookie();

	const { data, isLoading, error } = useQuery(["companyStats"], async () => {
		const stats = await apiService.MakeGetRequest("/companies/stats", token);
		return stats;
	});

	if (error) {
		return <p>{Messages.fr.content.FailedToLoadStats}</p>;
	}

	return (
		<>
			{isLoading ? (
				<CSpinner size="sm" color="success" />
			) : (
				<div className="row align-items-center flex-1">
					<div className="col-12 col-md-6 mb-4">
						<StatisticsCard
							title="Solde courant"
							text={`${data?.balance} DH`}
							textColor="#29129D"
							bgColor="#1DAB87"
							icon={<SoldeIcon />}
						/>
					</div>
					<div className="col-12 col-md-6 mb-4">
						<StatisticsCard
							title="Missions terminées"
							text={data?.endedOffersCount}
							textColor="#2ACC96"
							bgColor="#29129D"
						/>
					</div>
					<div className="col-12 col-md-6 mb-4">
						<StatisticsCard
							title="Revenu"
							text={`${data?.revenue} DH`}
							textColor="#29129D"
							bgColor="#FFB800"
							icon={<RevenuIcon />}
						/>
					</div>
					<div className="col-12 col-md-6 mb-4">
						<StatisticsCard
							title="Annulation"
							text={data?.cancledOffersCount}
							textColor="#29129D"
							bgColor="#FC376B"
						/>
					</div>
				</div>
			)}
		</>
	);
}
